











































import { computed, defineComponent, toRefs, ref, PropType } from '@vue/composition-api';
import { OptimizationGoalOptionItem } from '../types';
import { OptimizeGoal } from '@tt4b/ttam-enums';

const name = 'ttam-optimization-default-select';

export default defineComponent({
  name,
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    options: {
      type: Array as PropType<OptimizationGoalOptionItem[]>,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { options } = toRefs(props);
    const _optimizationGoal = computed({
      get: () => props.value,
      set: v => emit('change', v),
    });

    const noSelection = computed(() => !options.value?.length);
    const selectedOptGoalLabel = computed(() => {
      const item = options.value?.find?.(v => v.value === _optimizationGoal.value);

      return item?.label || '';
    });

    const isShowOptionPopover = ref(true);

    const onLpvClick = () => {
      _optimizationGoal.value = OptimizeGoal.LANDING_PAGE_VIEW;
    };

    const onBlur = () => {
      // 部分浏览器下blur事件早于popover内的按钮的click事件
      setTimeout(() => {
        isShowOptionPopover.value = false;
      }, 100);
      setTimeout(() => {
        isShowOptionPopover.value = true;
      }, 200);
    };

    const onVisibleChange = (isVisible: boolean) => {
      emit('visible-change', isVisible);
    };

    return {
      name,
      _optimizationGoal,
      noSelection,
      selectedOptGoalLabel,

      isShowOptionPopover,
      onVisibleChange,
      onLpvClick,
      onBlur,
      OptimizeGoal,
    };
  },
});
